import { NewDynamicTab } from "../../components/Page";
import { GridcoTitle } from "./components";
import { TabSwitcher } from "./Gridco_Das";
import  UploadFile  from "./UploadFile";

export function Gridco() {
  return (
    <NewDynamicTab 
     showDates={false}
     headerPrefixComponent={<TabSwitcher />}
     middleComponent={<GridcoTitle />}
        tabs={
            {  "Upload File": <UploadFile />}
        }
        showTabs={false}
        header="Upload Form"
    />
  );
}